var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppdev2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-28"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-28",
    cx: 250,
    cy: 333.49,
    rx: 236,
    ry: 136.23,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-28",
    d: "M41.12,306.5,298.56,455.13a11.08,11.08,0,0,0,10,0L448.7,374.22c2.76-1.6,2.76-4.18,0-5.78L191.26,219.81a11.08,11.08,0,0,0-10,0L41.12,300.72C38.35,302.32,38.35,304.9,41.12,306.5Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.46,290.43l10.36-4.67s4.52-20.73,4.57-37.13c.06-23-11.9-52-30.14-47.33s5.06,30.5,8.81,50.44S60.46,290.43,60.46,290.43Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.46,290.43l10.36-4.67s4.52-20.73,4.57-37.13c.06-23-11.9-52-30.14-47.33s5.06,30.5,8.81,50.44S60.46,290.43,60.46,290.43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.85,288.57h0a.59.59,0,0,1-.51-.67c6.85-50.54-15.82-78.6-16-78.88a.59.59,0,0,1,.08-.84.6.6,0,0,1,.84.08c.23.28,23.23,28.75,16.31,79.8A.6.6,0,0,1,65.85,288.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,293.33,61.32,290s2.64-14.27-2.65-32.47c-4.6-15.84-18.57-30-26.5-28.13s-8.3,7.34-5.13,13.42S51.56,264.79,54,293.33Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,293.33,61.32,290s2.64-14.27-2.65-32.47c-4.6-15.84-18.57-30-26.5-28.13s-8.3,7.34-5.13,13.42S51.56,264.79,54,293.33Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.78,292.17h0a.6.6,0,0,1-.53-.65c3.38-32.06-24.54-56.77-24.82-57a.59.59,0,1,1,.78-.89c.29.25,28.67,25.37,25.23,58A.6.6,0,0,1,57.78,292.17Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--like-icon--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.15,114.75a5.38,5.38,0,0,0-.22-1.61l5.85-6.7-7.5-4.21c-.71-.49-1.72-.55-3.09.25l-13,7.55-1.75,1a35,35,0,0,0,.62-4.57c.05-.64.06-1.25.06-1.86l.24.12,4.39-5.13-7.5-4.22h0c-2.52-1.54-6.78,1.5-6.78,2.73,0,1.48.64,9.23,0,11.45s-7.34,17.53-7.34,17.53v1l0,30.9,24.45-14.14c3.21-1.86,5.44-5.82,5.44-8.5a8.39,8.39,0,0,0-.65-3.5c2.08-1.2,4.15-5.54,4.15-7.38,0-2.78-.95-3.5-.95-3.5A10.56,10.56,0,0,0,399.15,114.75Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.15,114.75a5.38,5.38,0,0,0-.22-1.61l5.85-6.7-7.5-4.21c-.71-.49-1.72-.55-3.09.25l-13,7.55-1.75,1a35,35,0,0,0,.62-4.57c.05-.64.06-1.25.06-1.86l.24.12,4.39-5.13-7.5-4.22h0c-2.52-1.54-6.78,1.5-6.78,2.73,0,1.48.64,9.23,0,11.45s-7.34,17.53-7.34,17.53v1l0,30.9,24.45-14.14c3.21-1.86,5.44-5.82,5.44-8.5a8.39,8.39,0,0,0-.65-3.5c2.08-1.2,4.15-5.54,4.15-7.38,0-2.78-.95-3.5-.95-3.5A10.56,10.56,0,0,0,399.15,114.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.86 163.37 363.12 158.9 363.1 126.98 370.83 131.45 370.86 163.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.86 163.37 363.12 158.9 363.1 126.98 370.83 131.45 370.86 163.37",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.86 163.37 363.12 158.9 363.1 126.98 370.83 131.45 370.86 163.37",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.53,130.45c0,4.12-2.35,5.57-4.43,6.77a8.66,8.66,0,0,1,.63,3.52c0,2.66-2.22,6.64-5.42,8.48l-24.45,14.14,0-30.56v-1.35s6.72-15.31,7.35-17.54,0-10,0-11.43,6.07-5.54,8-1.3,2.09,8.56,1,14.2l14.78-8.55c3.12-1.8,4.4.78,4.4,2.8,0,2.87-1.34,5.7-3.12,6.78,0,0,3.4.17,3.4,4.13a8.37,8.37,0,0,1-3.28,6.45S404.53,127.69,404.53,130.45Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.66 175.87 367.34 169.71 367.31 132.56 356.66 138.72 356.66 175.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.66 175.87 348.92 171.41 348.92 134.26 356.66 138.72 356.66 175.87",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.58 128.1 367.31 132.56 356.66 138.72 348.92 134.26 359.58 128.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.17,113.91c-.63,2.23-7.35,17.54-7.35,17.54l-7.72-4.35s6.7-15.32,7.34-17.53,0-10,0-11.45l7.74,4.36C378.17,104,378.82,111.7,378.17,113.91Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.17,113.91c-.63,2.23-7.35,17.54-7.35,17.54l-7.72-4.35s6.7-15.32,7.34-17.53,0-10,0-11.45l7.74,4.36C378.17,104,378.82,111.7,378.17,113.91Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--heart-icon--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.91,146.35h0l-7.36-4.59h0c-2.72-1.74-6.86-1.56-11.56,1-6.5,3.47-12.24,12.23-14.72,19.66L430,159.14h0c-2.67-1.93-6.42-2.34-10.65-.08-.52.28-1,.59-1.56.91l-.81.55c-.23.16-.47.31-.7.48s-.72.55-1.07.83l-.4.31c-.41.34-.82.7-1.22,1.07l-.18.17c-.45.41-.88.84-1.31,1.28l0,0a34.3,34.3,0,0,0-3.6,4.39h0c-3,4.3-4.9,9.1-5,13.36-.26,7.93,4.47,13.15,10.38,16.58h0l5.81,3.61h0a41.44,41.44,0,0,0,11.14,5l9.67,2.91L450.67,197c9.73-12.9,21.41-30.78,21.8-42.74C472.6,150.45,471.24,147.74,468.91,146.35Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.57,202.58,413.84,199c-5.9-3.43-10.64-8.65-10.38-16.58.14-4.25,2.07-9.07,5.05-13.36l7.55,4.69c-3,4.29-4.91,9.11-5.05,13.36C410.78,194.23,414.54,199.16,419.57,202.58Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.57,202.58,413.84,199c-5.9-3.43-10.64-8.65-10.38-16.58.14-4.25,2.07-9.07,5.05-13.36l7.55,4.69c-3,4.29-4.91,9.11-5.05,13.36C410.78,194.23,414.54,199.16,419.57,202.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M468.88,146.3c-2.73-1.58-6.78-1.33-11.34,1.11-7.84,4.18-14.6,16.06-15.82,24-.74-6.91-6.94-11.87-14.78-7.67a32.24,32.24,0,0,0-10.88,10l-7.55-4.69.38-.54c.11-.15.21-.29.33-.44l.84-1.1a35.24,35.24,0,0,1,2.6-2.87c.22-.24.46-.46.69-.68l.5-.46a29.08,29.08,0,0,1,5.54-3.94,11.8,11.8,0,0,1,5.9-1.53,8.49,8.49,0,0,1,4.75,1.61l5.23,3.22c2.47-7.42,8.22-16.17,14.73-19.64,4.7-2.52,8.83-2.7,11.55-1h0Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.88,146.3c-2.73-1.58-6.78-1.33-11.34,1.11-7.84,4.18-14.6,16.06-15.82,24-.74-6.91-6.94-11.87-14.78-7.67a32.24,32.24,0,0,0-10.88,10l-7.55-4.69.38-.54c.11-.15.21-.29.33-.44l.84-1.1a35.24,35.24,0,0,1,2.6-2.87c.22-.24.46-.46.69-.68l.5-.46a29.08,29.08,0,0,1,5.54-3.94,11.8,11.8,0,0,1,5.9-1.53,8.49,8.49,0,0,1,4.75,1.61l5.23,3.22c2.47-7.42,8.22-16.17,14.73-19.64,4.7-2.52,8.83-2.7,11.55-1h0Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--twitter-icon--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.45,69.31l-7.4-4.6-2.84,5.72,4,4.37s.24.86,2.19-.65A22.91,22.91,0,0,0,349.45,69.31Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.45,69.31l-7.4-4.6-2.84,5.72,4,4.37s.24.86,2.19-.65A22.91,22.91,0,0,0,349.45,69.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,79.42c0,9-2.59,20-7.39,30.12-5.48,11.58-13.82,22.15-24.4,27.81-6.06,3.24-11.61,3.92-16.21,2.48l-7.4-4.6c4.8-1.83,9.67-5.79,13.87-11.24l-4.54-2.83a7.22,7.22,0,0,1-3-4.59,10.88,10.88,0,0,0,3.08-1.48l-3-1.88c-2.27-1.41-3.55-4.61-3.34-8.79a7.56,7.56,0,0,0,4.79-.83,5.42,5.42,0,0,1-1.31-.68c-3.5-2.49-4.09-9.26-1.39-16.26L301,91.24c4.08,1.1,9,.7,14.2-1.74-1.27-7.93,4.08-19.08,11-22.78,3.08-1.64,5.81-1.43,7.67.26a41.6,41.6,0,0,0,6.91-7l7.4,4.6a28.13,28.13,0,0,1-5,10.26,35.87,35.87,0,0,0,6.21-5.49A56.25,56.25,0,0,1,343.86,79.42Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,79.42c0,9-2.59,20-7.39,30.12-5.48,11.58-13.82,22.15-24.4,27.81-6.06,3.24-11.61,3.92-16.21,2.48,5.65-2.16,11.39-7.25,16-14.27-4.68,2.38-8.5.46-9.68-4.39a12.85,12.85,0,0,0,4.84-2.82c-5.1,1.39-8.46-2.78-8.13-9.33a7.59,7.59,0,0,0,4.8-.83,5.58,5.58,0,0,1-1.07-.52c-3.71-2.34-4.4-9.27-1.63-16.42.79,3.73,7.71,6.61,13.69,6.52,5.78-.09,7.77-3.45,7.88-3.66h0c-1.27-7.93,4.09-19.08,11-22.78,3.07-1.64,5.8-1.43,7.67.25a41.16,41.16,0,0,0,6.91-7,28.13,28.13,0,0,1-5,10.26,35.87,35.87,0,0,0,6.21-5.49A56.25,56.25,0,0,1,343.86,79.42Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.19,64.54v0a41.72,41.72,0,0,1-6.9,7,4.94,4.94,0,0,0-1.65-1L333.88,67a41.6,41.6,0,0,0,6.91-7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,118.35a12.85,12.85,0,0,1-4.84,2.82l-7.39-4.6a10.88,10.88,0,0,0,3.08-1.48l4.19,2.6.13.09.19.12A5.91,5.91,0,0,0,307.06,118.35Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.61,94.1h0s0,0,0,0c-.22.39-2.26,3.54-7.86,3.63-6,.09-12.9-2.79-13.69-6.52h0a17.46,17.46,0,0,0,3.88.58,22.63,22.63,0,0,0,10.32-2.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301,91.25h0l-7.39-4.59c-2.7,7-2.11,13.77,1.39,16.26l.5.31.68.43,6.46,4C299,105.34,298.26,98.41,301,91.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.73,108.19a7.59,7.59,0,0,1-4.8.83l-7.39-4.6a7.51,7.51,0,0,0,4.66-.77l6.46,4A6.2,6.2,0,0,0,303.73,108.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9,125.56c-4.65,7-10.39,12.11-16,14.27l-7.4-4.6c4.8-1.84,9.67-5.79,13.87-11.24l2.88,1.79C307,126.88,309.3,126.88,311.9,125.56Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,70.59c-1.68-.69-3.79-.49-6.08.73-6.91,3.7-12.27,14.85-11,22.78l-7.39-4.6c-1.27-7.93,4.08-19.08,11-22.78,3.08-1.64,5.81-1.43,7.67.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,117.69l-4.19-2.6-3-1.88c-2.27-1.41-3.55-4.61-3.34-8.79l7.39,4.6C298.73,113.08,299.94,116.22,302.1,117.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,125.64,302.33,124l-4.54-2.82a7.2,7.2,0,0,1-3-4.6l7.39,4.6A7.32,7.32,0,0,0,305,125.64Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Target--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--target--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.43,255.5l1.1-1.78-5.59-3.67c-4.79-3.4-11.73-3.25-19.44,1.23-14.38,8.36-26,28.63-25.95,45.26,0,7.88,2.66,13.53,6.95,16.41h0l5.52,3.64.92-1.51c3.77.26,8.11-.86,12.73-3.55,14.39-8.36,26-28.62,26-45.26A24.7,24.7,0,0,0,442.43,255.5Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.43,255.5l1.1-1.78-5.59-3.67c-4.79-3.4-11.73-3.25-19.44,1.23-14.38,8.36-26,28.63-25.95,45.26,0,7.88,2.66,13.53,6.95,16.41h0l5.52,3.64.92-1.51c3.77.26,8.11-.86,12.73-3.55,14.39-8.36,26-28.62,26-45.26A24.7,24.7,0,0,0,442.43,255.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.32,270c.05,16.63-11.57,36.9-26,45.26s-26.08,1.65-26.12-15,11.57-36.9,25.95-45.26S450.27,253.38,450.32,270Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,272.54c0,13.86-9.64,30.75-21.62,37.72s-21.74,1.37-21.78-12.49,9.64-30.75,21.63-37.72S445.94,258.67,446,272.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.62,275.05c0,11.09-7.72,24.6-17.3,30.18s-17.37,1.11-17.4-10,7.71-24.6,17.3-30.18S441.6,264,441.62,275.05Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.3,277.58c0,8.32-5.79,18.45-13,22.64s-13,.82-13.06-7.49,5.78-18.46,13-22.64S437.27,269.27,437.3,277.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.25,275.11c-4.8,2.79-8.67,9.55-8.65,15.09s3.91,7.79,8.71,5,8.67-9.55,8.65-15.09S429.05,272.32,424.25,275.11Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.26,280.13a9.64,9.64,0,0,0-4.32,7.55c0,2.77,1.95,3.89,4.35,2.5a9.63,9.63,0,0,0,4.33-7.55C428.61,279.86,426.66,278.74,424.26,280.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.73 307.55 461.93 305.14 458.33 304.97 458.33 305.62 463.83 308.8 467.73 308.2 467.73 307.55",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.33 304.97 461.93 305.14 467.73 307.55 463.83 308.15 458.33 304.97",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.83 308.8 463.83 308.15 467.73 307.55 467.73 308.2 463.83 308.8",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.83 308.15 458.33 304.97 458.33 305.62 463.83 308.8 463.83 308.15",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.62 287.59 424.71 285.15 424.71 286.39 428.63 291.71 430.78 289.65 430.78 289.65 433.62 288.83 433.62 287.59",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.71 285.15 428.63 290.47 430.78 288.42 430.78 288.42 433.62 287.59 424.71 285.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.63 290.47 428.63 291.71 430.78 289.65 430.78 288.42 428.63 290.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.78 288.42 433.62 287.59 433.62 288.83 430.78 289.65 430.78 288.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.16,288.41a.4.4,0,0,0-.42,0,1.33,1.33,0,0,0-.6,1,.41.41,0,0,0,.18.39h0l36.28,21,.82-1.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.27,289a1.24,1.24,0,0,0-.13.51.41.41,0,0,0,.18.39h0l36.28,21,.37-.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,309.41a1.32,1.32,0,0,0-.59,1c0,.38.26.54.59.35a1.3,1.3,0,0,0,.59-1C467.6,309.38,467.34,309.22,467,309.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.44 309.02 463.44 309.02 463.44 308.37 457.95 305.19 457.95 305.85 458.24 307.92 462.4 311.28 463.44 309.03 463.44 309.02",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.95 305.19 458.25 307.27 458.24 307.92 457.95 305.85 457.95 305.19",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.44 308.37 462.4 310.62 462.4 311.27 463.44 309.02 463.44 308.37",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.25 307.27 462.4 310.62 462.4 311.27 458.24 307.92 458.25 307.27",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "467.49 261.45 461.69 263.86 458.1 264.03 458.1 263.38 463.59 260.2 467.49 260.8 467.49 261.45",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.1 264.03 461.69 263.86 467.49 261.45 463.59 260.85 458.1 264.03",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.59 260.2 463.59 260.85 467.49 261.45 467.49 260.8 463.59 260.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.59 260.85 458.1 264.03 458.1 263.38 463.59 260.2 463.59 260.85",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.38 281.41 424.48 283.85 424.48 282.61 428.39 277.3 430.54 279.35 430.54 279.35 433.38 280.17 433.38 281.41",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.48 283.85 428.39 278.53 430.54 280.59 430.54 280.59 433.38 281.41 424.48 283.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.39 278.53 428.39 277.3 430.54 279.35 430.54 280.59 428.39 278.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.54 280.59 433.38 281.41 433.38 280.17 430.54 279.35 430.54 280.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.92,280.59a.38.38,0,0,1-.42,0,1.33,1.33,0,0,1-.6-1,.42.42,0,0,1,.18-.39h0l36.28-21,.82,1.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,280a1.09,1.09,0,0,1-.14-.51.42.42,0,0,1,.18-.39h0l36.28-21,.37.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.77,259.59a1.31,1.31,0,0,1-.59-1c0-.38.26-.54.59-.35a1.31,1.31,0,0,1,.59,1C467.36,259.62,467.1,259.78,466.77,259.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.2 259.98 463.2 259.98 463.2 260.63 457.71 263.81 457.71 263.15 458 261.08 462.16 257.72 463.2 259.98 463.2 259.98",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.71 263.81 458.01 261.73 458 261.08 457.71 263.15 457.71 263.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.2 260.63 462.16 258.38 462.16 257.73 463.2 259.98 463.2 260.63",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.01 261.73 462.16 258.38 462.16 257.73 458 261.08 458.01 261.73",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.73,279.23l-4.31-11.05,3.47-10V252l-10.62,6.13v6.13l4.57,10.85a.67.67,0,0,0,.31.27h0Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,279.23l-4.31-11.05,3.47-10V252l-10.62,6.13v6.13l4.57,10.85a.67.67,0,0,0,.31.27h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.36,232.3a7,7,0,0,0-3.18-5.51L385,226a7.05,7.05,0,0,0-6.36,0l-43.27,25a7,7,0,0,0-3.18,5.51v14.62a7,7,0,0,0,3.18,5.51l1.22.75a7,7,0,0,0,6.36,0l16-9.25L363.49,279a.68.68,0,0,0,1.23-.11L369.54,262l16.64-9.61a7,7,0,0,0,3.18-5.51Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.15,271.15a7,7,0,0,0,3.18,5.51l1.22.75a7.1,7.1,0,0,0,5.82.26c-1.5.56-2.64-.28-2.64-2.1V261a6.46,6.46,0,0,1,.93-3.14l-7.58-4.42a6.46,6.46,0,0,0-.93,3.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.26,231.4c-.37-1.35-1.61-1.78-3.08-.94l-43.27,25a6.18,6.18,0,0,0-2.24,2.37l-7.58-4.41a6.45,6.45,0,0,1,2.24-2.38l43.26-25a7.07,7.07,0,0,1,6.37,0l1.22.75A7.1,7.1,0,0,1,389.26,231.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.64,270.69a1.61,1.61,0,0,1-1.18,0,.54.54,0,0,1-.22-.46,3.09,3.09,0,0,1,.25-1.11,1.58,1.58,0,0,1,.56-.81.91.91,0,0,1,.43-.08h.43a2.58,2.58,0,0,0,1.16-.34,3.23,3.23,0,0,0,.91-.78,1.63,1.63,0,0,0,.39-1.08,1,1,0,0,0-.2-.66.83.83,0,0,0-.5-.23,5.36,5.36,0,0,0-.85,0,2.83,2.83,0,0,1-1.86-.46,2.36,2.36,0,0,1-.57-1.85,5.14,5.14,0,0,1,1-2.94,7.74,7.74,0,0,1,2.57-2.34,5.3,5.3,0,0,1,1.22-.53,2.32,2.32,0,0,1,1-.14c.21,0,.31.16.31.41a3.49,3.49,0,0,1-.2,1,1.34,1.34,0,0,1-.48.77,1.91,1.91,0,0,1-.49.15,3.46,3.46,0,0,0-1.1.38,2.43,2.43,0,0,0-.92.82,1.63,1.63,0,0,0-.26.8c0,.42.11.67.33.77a2.8,2.8,0,0,0,1,.12h.39a2.43,2.43,0,0,1,1.68.48,2.36,2.36,0,0,1,.51,1.75,5.42,5.42,0,0,1-.4,2,7,7,0,0,1-1.23,2,8.09,8.09,0,0,1-2.05,1.67A6.91,6.91,0,0,1,345.64,270.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.13,266.54v-10.8c0-.36.33-.73,1-1.1l.71-.41c.64-.37,1-.38,1,0v4.17l2.89-1.67v-4.17c0-.36.33-.72,1-1.1l.69-.4c.65-.38,1-.38,1,0v10.81c0,.36-.33.72-1,1.1l-.69.4c-.65.38-1,.38-1,0v-4.4l-2.89,1.67V265c0,.36-.32.73-1,1.1l-.71.41C352.46,266.89,352.13,266.9,352.13,266.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.33,261.4a1.56,1.56,0,0,1,.05-.33l2.6-12.24c.08-.36.42-.71,1-1.06l1.1-.64c.62-.35,1-.4,1-.13l2.6,9.23c0,.15,0,.24,0,.29,0,.25-.25.51-.73.79l-.89.52c-.54.31-.84.36-.9.16l-.44-1.81-2.56,1.48-.46,2.32c0,.27-.31.54-.79.82l-.88.5C361.6,261.62,361.33,261.65,361.33,261.4Zm5.22-7.11-.76-3.14q-.12-.54-.21-1.17l-.08.05c-.06.48-.12.95-.2,1.4l-.75,4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.73,255.8V245.17a1.08,1.08,0,0,1,.16-.6,1.49,1.49,0,0,1,.52-.46l2.81-1.63a3.63,3.63,0,0,1,2.5-.67c.63.14.95.82.95,2a5.63,5.63,0,0,1-1.61,3.77v.07a.93.93,0,0,1,.68.29,1.88,1.88,0,0,1,.45.75l1,2.66.05.18q0,.45-1.05,1.05l-.59.35c-.59.34-.93.38-1,.13l-.89-2.69a.58.58,0,0,0-.35-.33,1.07,1.07,0,0,0-.62.21l-.4.23v3.81c0,.36-.34.74-1,1.13l-.58.33C371.07,256.15,370.73,256.16,370.73,255.8Zm3.54-8.32a1.7,1.7,0,0,0,.64-.74,2.72,2.72,0,0,0,.26-1.23c0-.47-.09-.76-.26-.88a.63.63,0,0,0-.69.06l-.89.52V248Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.59,251c-.1,0-.15-.2-.15-.43V240.15a1.17,1.17,0,0,1,.15-.61,1.32,1.32,0,0,1,.47-.43l5-2.87c.17-.1.29-.11.37,0a.94.94,0,0,1,.12.58v.52a1.78,1.78,0,0,1-.12.71.89.89,0,0,1-.37.42l-3,1.71v2.45l2.63-1.52c.17-.1.3-.1.37,0a.92.92,0,0,1,.12.57v.52a1.75,1.75,0,0,1-.12.71.84.84,0,0,1-.37.42l-2.63,1.52v2.73l3-1.72c.17-.1.29-.1.36,0a1.06,1.06,0,0,1,.11.58v.52a2,2,0,0,1-.11.71.84.84,0,0,1-.36.41l-5,2.88A.57.57,0,0,1,379.59,251Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319,249.5l-4.31-11.05,3.47-10v-6.13l-10.61,6.13v6.12l4.56,10.85a.69.69,0,0,0,.31.28h0Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,249.5l-4.31-11.05,3.47-10v-6.13l-10.61,6.13v6.12l4.56,10.85a.69.69,0,0,0,.31.28h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.92,200.62a7,7,0,0,0-3.18-5.51l-1.22-.75a7.05,7.05,0,0,0-6.36,0l-49.93,28.83a7,7,0,0,0-3.18,5.51v14.61a7.07,7.07,0,0,0,3.18,5.52l1.22.74a7,7,0,0,0,6.36,0l19.35-11.15,4.56,10.84a.68.68,0,0,0,1.23-.12l4.81-16.84,20-11.55a7,7,0,0,0,3.18-5.51Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.05,243.31a7.07,7.07,0,0,0,3.18,5.52l1.22.74a7.1,7.1,0,0,0,5.82.26c-1.5.57-2.64-.28-2.64-2.09V233.12a6.57,6.57,0,0,1,.93-3.14L285,225.56a6.57,6.57,0,0,0-.93,3.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.82,199.72c-.37-1.35-1.61-1.78-3.08-.94l-49.93,28.83a6.29,6.29,0,0,0-2.24,2.38L285,225.57a6.47,6.47,0,0,1,2.25-2.38l49.91-28.83a7.07,7.07,0,0,1,6.37,0l1.22.75A7.06,7.06,0,0,1,347.82,199.72Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.81,241.93v-9.57a1,1,0,0,1,.14-.55,1.23,1.23,0,0,1,.42-.39l4.18-2.41c.15-.09.26-.09.33,0a.85.85,0,0,1,.11.52V230a1.67,1.67,0,0,1-.11.64.79.79,0,0,1-.33.37l-2.37,1.37v2.22l2.23-1.29c.15-.09.26-.09.34,0a.84.84,0,0,1,.1.51v.47a1.62,1.62,0,0,1-.1.64.84.84,0,0,1-.34.38l-2.23,1.29v4c0,.32-.3.65-.88,1l-.61.35C297.1,242.24,296.81,242.25,296.81,241.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,233.52c0-3.62,1.32-6.2,4-7.74,1.29-.74,2.28-.87,2.95-.38s1,1.67,1,3.53a10,10,0,0,1-1,4.7,7.54,7.54,0,0,1-2.95,3C304.27,238.19,303,237.15,303,233.52Zm4.87.33a3.72,3.72,0,0,0,.5-1.34,11.85,11.85,0,0,0,.17-2.19,8.74,8.74,0,0,0-.17-2c-.11-.43-.28-.69-.5-.76a1.1,1.1,0,0,0-.88.2,2.69,2.69,0,0,0-.89.82,3.53,3.53,0,0,0-.51,1.35,10.9,10.9,0,0,0-.18,2.18,8.09,8.09,0,0,0,.18,2c.11.44.28.69.51.76a1.17,1.17,0,0,0,.89-.21A2.55,2.55,0,0,0,307.82,233.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.47,233.19c-.09,0-.14-.17-.14-.38v-9.57c0-.32.3-.66.89-1l.6-.36c.59-.34.88-.34.88,0v8.19l2.27-1.31c.16-.09.28-.1.35,0a.88.88,0,0,1,.1.52v.47a1.65,1.65,0,0,1-.1.64.8.8,0,0,1-.35.38l-4.07,2.35C312.7,233.21,312.56,233.24,312.47,233.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.67,229.62c-.09-.05-.14-.17-.14-.39v-9.57c0-.32.3-.65.88-1l.61-.35c.59-.34.88-.35.88,0v8.19l2.27-1.3c.16-.1.27-.11.35,0a.84.84,0,0,1,.1.51v.47a1.62,1.62,0,0,1-.1.64.94.94,0,0,1-.35.39l-4.07,2.34C318.9,229.63,318.76,229.66,318.67,229.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.14,221.29q0-5.44,4-7.74c1.3-.75,2.28-.88,2.95-.38s1,1.67,1,3.53a9.87,9.87,0,0,1-1,4.7,7.47,7.47,0,0,1-2.95,3Q324.15,226.73,324.14,221.29Zm4.88.32a3.65,3.65,0,0,0,.5-1.34,11.85,11.85,0,0,0,.16-2.18,8.74,8.74,0,0,0-.16-2c-.11-.44-.28-.69-.5-.77a1.18,1.18,0,0,0-.89.21,2.64,2.64,0,0,0-.88.81,3.83,3.83,0,0,0-.52,1.36,10.8,10.8,0,0,0-.18,2.17,8.09,8.09,0,0,0,.18,2c.12.44.29.7.52.77a1.15,1.15,0,0,0,.88-.21A2.6,2.6,0,0,0,329,221.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.7,220.46a.15.15,0,0,1-.2-.13l-2-8.6a.53.53,0,0,1,0-.13.41.41,0,0,0,0-.1c0-.26.3-.57.9-.91l.44-.26c.6-.35.93-.38,1-.09l.71,5.2.14,1,.14,1.11.27-2a3.4,3.4,0,0,0,.07-.48l.93-6.3a.58.58,0,0,1,.19-.35,2.43,2.43,0,0,1,.53-.38l.76-.44a1.81,1.81,0,0,1,.52-.23c.11,0,.17,0,.19.14l.91,5.23.34,2.14.21-1.75.09-.75.73-6c0-.34.36-.68,1-1l.35-.21q.9-.51.9-.12a1.66,1.66,0,0,1,0,.24l-2,10.92c0,.23-.28.48-.71.73l-1,.58c-.4.23-.63.26-.68.07l-1-4.76-.17-1.53L338,213l-1.05,6c0,.23-.27.47-.68.71l-1,.58A1.58,1.58,0,0,1,334.7,220.46Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelopes--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mails--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letter--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.33,173.21l42-24.25a.86.86,0,0,1,1.05,0c.25.2,2.62,1.45,2.88,1.64a1.34,1.34,0,0,1,.44,1.13v37.8a3.47,3.47,0,0,1-1.45,2.77l-7.37,4.26-38.55-22.25A2.82,2.82,0,0,1,229.33,173.21Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,173.21l42-24.25a.86.86,0,0,1,1.05,0c.25.2,2.62,1.45,2.88,1.64a1.34,1.34,0,0,1,.44,1.13v37.8a3.47,3.47,0,0,1-1.45,2.77l-7.37,4.26-38.55-22.25A2.82,2.82,0,0,1,229.33,173.21Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,216.61c-.29-.19-2.68-1.51-2.94-1.69a1.33,1.33,0,0,1-.46-1.14V176a3.58,3.58,0,0,1,.46-1.67l38.55,22.25-34.63,20A.9.9,0,0,1,231.28,216.61Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.28,216.61c-.29-.19-2.68-1.51-2.94-1.69a1.33,1.33,0,0,1-.46-1.14V176a3.58,3.58,0,0,1,.46-1.67l38.55,22.25-34.63,20A.9.9,0,0,1,231.28,216.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.26,216.55l42-24.25a3.47,3.47,0,0,0,1.45-2.77v-37.8c0-1.06-.65-1.55-1.45-1.09l-42,24.25a3.47,3.47,0,0,0-1.45,2.77v37.8C230.81,216.52,231.46,217,232.26,216.55Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,215.46v-.75l17.37-28.78L231,176.43l.13-.31L252.52,185c.45.18,1-.15,1.49-.86l21.33-33.52a1,1,0,0,1,.13.15l-17.12,29.26,17.36,8.73v.74a3.87,3.87,0,0,1-.43,1.71l-17.81-9.67-2.53,4.31c-1,1.71-2.36,2.5-3.36,1.94l-2.52-1.4-17.78,30.19A1.35,1.35,0,0,1,230.81,215.46Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--letter--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.76,179.34l42-24.25a.89.89,0,0,1,1.06,0c.24.21,2.62,1.46,2.88,1.64a1.36,1.36,0,0,1,.44,1.14v37.8a3.5,3.5,0,0,1-1.45,2.77l-7.38,4.25-38.54-22.25A2.88,2.88,0,0,1,239.76,179.34Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.76,179.34l42-24.25a.89.89,0,0,1,1.06,0c.24.21,2.62,1.46,2.88,1.64a1.36,1.36,0,0,1,.44,1.14v37.8a3.5,3.5,0,0,1-1.45,2.77l-7.38,4.25-38.54-22.25A2.88,2.88,0,0,1,239.76,179.34Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.7,222.74c-.28-.18-2.67-1.51-2.93-1.68a1.34,1.34,0,0,1-.46-1.15v-37.8a3.65,3.65,0,0,1,.46-1.67l38.54,22.25-34.62,20A.92.92,0,0,1,241.7,222.74Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.7,222.74c-.28-.18-2.67-1.51-2.93-1.68a1.34,1.34,0,0,1-.46-1.15v-37.8a3.65,3.65,0,0,1,.46-1.67l38.54,22.25-34.62,20A.92.92,0,0,1,241.7,222.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.69,222.69l42-24.25a3.5,3.5,0,0,0,1.45-2.77v-37.8c0-1.07-.65-1.56-1.45-1.1l-42,24.25a3.5,3.5,0,0,0-1.45,2.77v37.8C241.24,222.66,241.89,223.15,242.69,222.69Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,221.59v-.74l17.36-28.78-17.14-9.5a2.88,2.88,0,0,1,.13-.31l21.35,8.9c.46.19,1-.15,1.49-.86l21.33-33.51a.58.58,0,0,1,.13.14L268.78,186.2l17.36,8.72v.75a3.7,3.7,0,0,1-.44,1.7l-17.81-9.67L265.37,192c-1,1.71-2.36,2.5-3.36,2l-2.53-1.4L241.7,222.74A1.38,1.38,0,0,1,241.24,221.59Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--letter--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.18,185.48l42-24.25a.88.88,0,0,1,1.06,0c.24.2,2.61,1.45,2.87,1.64a1.31,1.31,0,0,1,.44,1.13v37.8a3.44,3.44,0,0,1-1.45,2.77l-7.37,4.26-38.55-22.25A2.82,2.82,0,0,1,250.18,185.48Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18,185.48l42-24.25a.88.88,0,0,1,1.06,0c.24.2,2.61,1.45,2.87,1.64a1.31,1.31,0,0,1,.44,1.13v37.8a3.44,3.44,0,0,1-1.45,2.77l-7.37,4.26-38.55-22.25A2.82,2.82,0,0,1,250.18,185.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.13,228.88c-.29-.19-2.68-1.51-2.94-1.69a1.33,1.33,0,0,1-.46-1.14v-37.8a3.58,3.58,0,0,1,.46-1.67l38.55,22.25-34.63,20A.9.9,0,0,1,252.13,228.88Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.13,228.88c-.29-.19-2.68-1.51-2.94-1.69a1.33,1.33,0,0,1-.46-1.14v-37.8a3.58,3.58,0,0,1,.46-1.67l38.55,22.25-34.63,20A.9.9,0,0,1,252.13,228.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.11,228.82l42-24.25a3.44,3.44,0,0,0,1.45-2.77V164c0-1.06-.64-1.55-1.45-1.09l-42,24.25a3.47,3.47,0,0,0-1.45,2.77v37.8C251.66,228.79,252.31,229.28,253.11,228.82Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,227.73V227L269,198.2l-17.15-9.5.13-.31,21.36,8.91c.45.18,1-.15,1.49-.86l21.33-33.52a1.79,1.79,0,0,1,.13.14L279.2,192.33l17.36,8.73v.74a3.9,3.9,0,0,1-.43,1.71l-17.81-9.67-2.52,4.31c-1,1.71-2.37,2.5-3.37,1.94l-2.52-1.4-17.78,30.19A1.35,1.35,0,0,1,251.66,227.73Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mobile--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.31,372.84,313.63,441.93a12.92,12.92,0,0,1-12.49.24L60.19,303c-3.8-2.19-6.88-7.09-6.88-11s3.08-8.75,6.87-10.95L179.43,212.3a15.25,15.25,0,0,1,13.74,0L433.31,351c3.8,2.19,6.88,7.09,6.88,10.95S437.11,370.65,433.31,372.84Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.43,212.3,60.18,281.14c-3.79,2.2-6.87,7.1-6.87,10.95s3.08,8.76,6.88,11l241,139.13a13.48,13.48,0,0,0,6,1.48V278.09l-114-65.79A15.25,15.25,0,0,0,179.43,212.3Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.63,441.93l119.68-69.09c3.8-2.19,6.88-7.09,6.88-10.94s-3.08-8.76-6.88-10.95L307.12,278.09V443.65A12.7,12.7,0,0,0,313.63,441.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.78,429.62a13.41,13.41,0,0,1-12.12,0L60.16,291.92c-5.13-3-5.13-7.8,0-10.76L179.42,212.3a15.25,15.25,0,0,1,13.74,0L433.3,351c3.78,2.18,3.78,5.75,0,7.93Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.78,429.62a13.41,13.41,0,0,1-12.12,0L60.16,291.92c-5.13-3-5.13-7.8,0-10.76L179.42,212.3a15.25,15.25,0,0,1,13.74,0L433.3,351c3.78,2.18,3.78,5.75,0,7.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.2,415.76a14.45,14.45,0,0,1-13.06,0L80.91,297.27c-3.61-2.08-3.61-5.46,0-7.54L193.1,225a14.51,14.51,0,0,1,13.06,0L411.39,343.45c3.59,2.07,3.59,5.47,0,7.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.23,223.43A13.09,13.09,0,0,0,193.1,225L80.91,289.73c-3.61,2.08-3.61,5.46,0,7.54l22.24,12.84,96.08-61.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.24,229.86a14.51,14.51,0,0,0-13.06,0L81,294.63A6.39,6.39,0,0,0,79.28,296a7.1,7.1,0,0,0,1.63,1.27L286.14,415.76a14.45,14.45,0,0,0,13.06,0L411.39,351a6.6,6.6,0,0,0,1.69-1.35,6.55,6.55,0,0,0-1.61-1.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,259.43,141.8,248c1.19-.68,1.25-1.76.13-2.4a4.59,4.59,0,0,0-4.16.08l-19.88,11.48c-1.19.68-1.25,1.76-.13,2.4A4.59,4.59,0,0,0,121.92,259.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.06,239.75a1.23,1.23,0,0,0,0-2.33,4.47,4.47,0,0,0-4,0,1.23,1.23,0,0,0,0,2.33A4.47,4.47,0,0,0,156.06,239.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.12,235.09a1.23,1.23,0,0,0,0-2.33,4.47,4.47,0,0,0-4,0,1.23,1.23,0,0,0,0,2.33A4.47,4.47,0,0,0,164.12,235.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.64,272.32a1.23,1.23,0,0,0,0-2.33,4.47,4.47,0,0,0-4,0,1.23,1.23,0,0,0,0,2.33A4.47,4.47,0,0,0,99.64,272.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7,267.66a1.23,1.23,0,0,0,0-2.33,4.47,4.47,0,0,0-4,0,1.23,1.23,0,0,0,0,2.33A4.47,4.47,0,0,0,107.7,267.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.77,338.8a4.59,4.59,0,0,1,2.15,3.56,1.37,1.37,0,0,1-.59,1.26l-1.51.87a1.57,1.57,0,0,1-1.55-.17l-27.94-16.14a4.59,4.59,0,0,1-2.15-3.56,1.38,1.38,0,0,1,.54-1.23c.27-.17,1.29-.75,1.55-.9a1.59,1.59,0,0,1,1.56.17Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.77,338.8a4.59,4.59,0,0,1,2.15,3.56,1.37,1.37,0,0,1-.59,1.26l-1.51.87a1.57,1.57,0,0,1-1.55-.17l-27.94-16.14a4.59,4.59,0,0,1-2.15-3.56,1.38,1.38,0,0,1,.54-1.23c.27-.17,1.29-.75,1.55-.9a1.59,1.59,0,0,1,1.56.17Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27,339.66l-27.94-16.13c-1.19-.69-2.15-.2-2.15,1.09a4.59,4.59,0,0,0,2.15,3.56l27.94,16.14c1.19.68,2.15.19,2.15-1.09A4.6,4.6,0,0,0,134.27,339.66Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27,339.66l-27.94-16.13c-1.19-.69-2.15-.2-2.15,1.09a4.59,4.59,0,0,0,2.15,3.56l27.94,16.14c1.19.68,2.15.19,2.15-1.09A4.6,4.6,0,0,0,134.27,339.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.37,317.2a4.62,4.62,0,0,1,2.14,3.57,1.32,1.32,0,0,1-.59,1.25c-.26.14-1.23.73-1.5.88a1.6,1.6,0,0,1-1.55-.18L83.7,315.11a4.59,4.59,0,0,1-2.15-3.56,1.38,1.38,0,0,1,.54-1.23l1.55-.9a1.55,1.55,0,0,1,1.55.18Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.37,317.2a4.62,4.62,0,0,1,2.14,3.57,1.32,1.32,0,0,1-.59,1.25c-.26.14-1.23.73-1.5.88a1.6,1.6,0,0,1-1.55-.18L83.7,315.11a4.59,4.59,0,0,1-2.15-3.56,1.38,1.38,0,0,1,.54-1.23l1.55-.9a1.55,1.55,0,0,1,1.55.18Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,318.07,83.7,310.46c-1.19-.68-2.15-.2-2.15,1.09a4.59,4.59,0,0,0,2.15,3.56l13.17,7.61c1.19.69,2.15.2,2.15-1.09A4.59,4.59,0,0,0,96.87,318.07Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.87,318.07,83.7,310.46c-1.19-.68-2.15-.2-2.15,1.09a4.59,4.59,0,0,0,2.15,3.56l13.17,7.61c1.19.69,2.15.2,2.15-1.09A4.59,4.59,0,0,0,96.87,318.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--message--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.17,362.78v.81a4.49,4.49,0,0,0,2,3.51l43.51,25.12a4.47,4.47,0,0,0,4.06,0l72.05-41.6a4.47,4.47,0,0,0,2-3.51v-.81a4.49,4.49,0,0,0-2-3.51l-43.51-25.12a4.47,4.47,0,0,0-4.06,0l-72.05,41.6A4.47,4.47,0,0,0,246.17,362.78Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.17,362.78v.81a4.49,4.49,0,0,0,2,3.51l43.51,25.12a4.47,4.47,0,0,0,4.06,0l72.05-41.6a4.47,4.47,0,0,0,2-3.51v-.81a4.49,4.49,0,0,0-2-3.51l-43.51-25.12a4.47,4.47,0,0,0-4.06,0l-72.05,41.6A4.47,4.47,0,0,0,246.17,362.78Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.82,342.79l-43.51-25.12a4.47,4.47,0,0,0-4.06,0L293.74,333v59.74h0a4.09,4.09,0,0,0,2-.49l72.05-41.6a4.47,4.47,0,0,0,2-3.51v-.81A4.49,4.49,0,0,0,367.82,342.79Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.82,342.79l-43.51-25.12a4.47,4.47,0,0,0-4.06,0L293.74,333v59.74h0a4.09,4.09,0,0,0,2-.49l72.05-41.6a4.47,4.47,0,0,0,2-3.51v-.81A4.49,4.49,0,0,0,367.82,342.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,333l-45.54,26.3a4.47,4.47,0,0,0-2,3.51v.81a4.49,4.49,0,0,0,2,3.51l43.51,25.12a4.07,4.07,0,0,0,2,.49h0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,333l-45.54,26.3a4.47,4.47,0,0,0-2,3.51v.81a4.49,4.49,0,0,0,2,3.51l43.51,25.12a4.07,4.07,0,0,0,2,.49h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,382.71l-36.54-21.1a1.23,1.23,0,0,1,0-2.34l72.05-41.6a4.47,4.47,0,0,1,4.06,0l43.51,25.12a1.23,1.23,0,0,1,0,2.34L355.87,352l-4.19,2.42-55.91,32.28a4.47,4.47,0,0,1-4.06,0l-3.54-2.05Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,382.71l-36.54-21.1a1.23,1.23,0,0,1,0-2.34l72.05-41.6a4.47,4.47,0,0,1,4.06,0l43.51,25.12a1.23,1.23,0,0,1,0,2.34L355.87,352l-4.19,2.42-55.91,32.28a4.47,4.47,0,0,1-4.06,0l-3.54-2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,347.66l49.9-4.87-49.46,2.8,5.95-27.92a4.23,4.23,0,0,0-2.21-.47L312.77,355l-65.39,5.39a1.35,1.35,0,0,0,.82,1.27L301,358.54l-7.27,28.68L303,358.43h0l9-.53a4.83,4.83,0,0,0,3-1.24h0a4.83,4.83,0,0,0,1.52-2.62Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,359.05l49.79-4.1,1.78-7.14,1-4,6.58-26.64a4.13,4.13,0,0,0-1.86.47l-36,20.8-36,20.8a1.45,1.45,0,0,0-.82,1.07l10-.82Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,311.71c4.55-2.63,11.93-2.63,16.48,0s4.55,6.89,0,9.51-11.93,2.63-16.48,0S309.49,314.34,314,311.71Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.52,318a.6.6,0,0,1-.34-.12.21.21,0,0,1-.09-.23l.68-3c0-.07,0-.16.08-.27a.49.49,0,0,1,.25-.27l1.66-1a.72.72,0,0,1,.37-.09.7.7,0,0,1,.37.09l8.83,5.1a.23.23,0,0,1,.15.21.25.25,0,0,1-.15.21l-1.79,1a.72.72,0,0,1-.37.09.7.7,0,0,1-.37-.09l-6-3.44-.4,1.65c0,.08-.08.15-.19.2a.84.84,0,0,1-.39.06Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.64,346.33l32.23-18.6,22,5.45a2.37,2.37,0,0,0,2.47-3.71l-8.26-11.12,32.22-18.61c2.38-1.38,2.38-3.63,0-5L220.85,257.5a9.64,9.64,0,0,0-8.66,0l-80.67,46.62c-2.38,1.37-2.38,3.62,0,5L196,346.33A9.57,9.57,0,0,0,204.64,346.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.85,297.27a25.9,25.9,0,0,1,6.05-2.58,28,28,0,0,1,5.77-1,20.49,20.49,0,0,1,5.15.31,18,18,0,0,1,4.18,1.33q2,1,4.12,2.19t3.78,2.37a8,8,0,0,1,2.3,2.42,4.23,4.23,0,0,1,.55,3A7.09,7.09,0,0,1,195,308.6a17.26,17.26,0,0,1-4.52,3.47,27,27,0,0,1-6,2.61,26.36,26.36,0,0,1-5.74,1,20.48,20.48,0,0,1-5.15-.32,17.79,17.79,0,0,1-4.19-1.32q-2-1-4.11-2.19t-3.79-2.38a7.8,7.8,0,0,1-2.29-2.41,4.25,4.25,0,0,1-.55-3,7.47,7.47,0,0,1,1.71-3.33A16.66,16.66,0,0,1,164.85,297.27Zm20.45,6.78a9.27,9.27,0,0,0-1.27-.83l-1.92-1.11L180.18,301a10.21,10.21,0,0,0-1.43-.73,8.71,8.71,0,0,0-3.49-.78,8.18,8.18,0,0,0-4.28,1.32c-1.59.92-2.36,1.74-2.3,2.47a2.89,2.89,0,0,0,1.36,2,12.65,12.65,0,0,0,1.23.85c.58.37,1.21.75,1.88,1.13s1.32.75,2,1.09a14.68,14.68,0,0,0,1.48.71,8.71,8.71,0,0,0,3.49.78,8.23,8.23,0,0,0,4.28-1.32c1.59-.92,2.36-1.74,2.29-2.48A2.84,2.84,0,0,0,185.3,304.05Zm14.23-24.82a2.42,2.42,0,0,1,.19-1.27,3.45,3.45,0,0,1,1.42-1.22l4.93-2.85a4.46,4.46,0,0,1,1.83-.61,2.71,2.71,0,0,1,1.57.29,1.23,1.23,0,0,1,.27.25,1,1,0,0,1,.18.39l5.67,50.17a2.47,2.47,0,0,1-.2,1.26,3.28,3.28,0,0,1-1.41,1.23l-4.93,2.85a4.38,4.38,0,0,1-1.83.6,2.63,2.63,0,0,1-1.57-.28,1,1,0,0,1-.28-.26,1.17,1.17,0,0,1-.18-.39Zm25.91,11.92a26.38,26.38,0,0,1,6.05-2.59,27.34,27.34,0,0,1,5.77-1,20.49,20.49,0,0,1,5.15.31,18,18,0,0,1,4.18,1.33q2,1,4.12,2.18t3.78,2.38a8,8,0,0,1,2.3,2.41,4.25,4.25,0,0,1,.55,3,7.14,7.14,0,0,1-1.75,3.31,17.48,17.48,0,0,1-4.52,3.47,26.35,26.35,0,0,1-6,2.6,25.59,25.59,0,0,1-5.73,1,20.49,20.49,0,0,1-5.15-.31,18.26,18.26,0,0,1-4.19-1.33c-1.34-.65-2.71-1.37-4.11-2.18s-2.66-1.6-3.79-2.38a8,8,0,0,1-2.29-2.42,4.21,4.21,0,0,1-.55-3,7.47,7.47,0,0,1,1.71-3.33A16.46,16.46,0,0,1,225.44,291.15Zm20.45,6.77a9.47,9.47,0,0,0-1.27-.82L242.7,296l-1.93-1.11a11.83,11.83,0,0,0-1.43-.74,9.05,9.05,0,0,0-3.49-.78,8.42,8.42,0,0,0-4.29,1.32c-1.58.92-2.35,1.75-2.29,2.48a2.89,2.89,0,0,0,1.36,2,13.11,13.11,0,0,0,1.22.86c.59.37,1.22.75,1.89,1.13s1.32.75,2,1.09,1.14.57,1.48.71a9,9,0,0,0,3.49.78,8.35,8.35,0,0,0,4.28-1.33c1.59-.91,2.35-1.74,2.29-2.47A2.88,2.88,0,0,0,245.89,297.92Z",
    style: {
      fill: "#FF7F00"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Megaphone--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--megaphone--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.75,101.58,96.87,94v60.36c0,2.27,2.63,4.54,2.63,4.54l-13.12,7.58s-2.63-2.28-2.63-4.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,101.45l5.53,7,0,26.23a39.07,39.07,0,0,1-6,20.75h0l19,11a7,7,0,0,1-2.63-4.55V110.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.33 155.48 67.33 158.51 86.38 169.51 86.38 166.48 67.33 155.48",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.38 169.51 99.5 161.93 99.5 158.9 86.38 166.48 86.38 169.51",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.38 169.51 99.5 161.93 99.5 158.9 86.38 166.48 86.38 169.51",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.15,69.71h0c-2.23-1.34-5.33-1.17-8.76.81l-.13.07C67.48,74.52,62,84,62,91.87V92c0,4,1.48,6.86,3.84,8.08h0l9.93,5.84L92.33,75.13Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.15,69.71h0c-2.23-1.34-5.33-1.17-8.76.81l-.13.07C67.48,74.52,62,84,62,91.87V92c0,4,1.48,6.86,3.84,8.08h0l9.93,5.84L92.33,75.13Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.82,100.1h0l9.93,5.84,5.5-10.21L63.12,85.26A21.77,21.77,0,0,0,62,91.87V92C62,96.07,63.46,98.88,65.82,100.1Z",
    style: {
      fill: "#FF7F00",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.59,77.26h0c-2.52-1.44-5.92-1.39-9.68.45-.4.19-.8.4-1.2.64s-.95.57-1.41.89A24.08,24.08,0,0,0,90.05,81a30.91,30.91,0,0,0-3.78,3.88,37,37,0,0,0-6.94,13.21,26.07,26.07,0,0,0-1,7c0,4.79,1.64,8.19,4.31,9.85l-9.49-5.47,0,0a12.23,12.23,0,0,1-5.6-10.57,25.66,25.66,0,0,1,.94-6.66,36.71,36.71,0,0,1,7-13.52,30.23,30.23,0,0,1,3.78-3.88A24,24,0,0,1,81.54,73c.47-.32.94-.62,1.41-.89s.81-.44,1.22-.63a12.16,12.16,0,0,1,10.74.18h0l.27.15.34.2Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.13,109.41l0,0a12.23,12.23,0,0,1-5.6-10.57,25.66,25.66,0,0,1,.94-6.66l10.84,5.9a26.07,26.07,0,0,0-1,7c0,4.79,1.64,8.19,4.31,9.85Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,87.24c0,9.83-6.89,21.77-15.4,26.68-4.27,2.48-8.15,2.69-10.94,1l-.15-.09c-2.67-1.66-4.31-5.06-4.31-9.85,0-9.82,6.89-21.77,15.4-26.68,4.24-2.45,8.09-2.69,10.88-1.09S109.11,82.32,109.11,87.24Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,87.24c0,9.83-6.89,21.77-15.4,26.68-4.27,2.48-8.15,2.69-10.94,1l-.15-.09c-2.67-1.66-4.31-5.06-4.31-9.85,0-9.82,6.89-21.77,15.4-26.68,4.24-2.45,8.09-2.69,10.88-1.09S109.11,82.32,109.11,87.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,84.7s-15.54,8-28.81,31a105.2,105.2,0,0,0-6.3,12.82c-6.66,16.35-6.11,27.62-6.11,27.62-4.63-11.35-10.39-23.09-20-32.08a144.75,144.75,0,0,0-11.81-9.88h0c-2.54-1.48-4-4.68-4-9.1A26.75,26.75,0,0,1,81,96a35.21,35.21,0,0,1,2.64-5.64A30.5,30.5,0,0,1,94.2,79.21c3.83-2.21,7.35-2.53,9.89-1.07h0a145,145,0,0,0,14.46,5.29C131.15,87.25,144.2,86.36,156.34,84.7Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,84.7s-15.54,8-28.81,31a105.2,105.2,0,0,0-6.3,12.82c-6.66,16.35-6.11,27.62-6.11,27.62-4.63-11.35-10.39-23.09-20-32.08a144.75,144.75,0,0,0-11.81-9.88h0c-2.54-1.48-4-4.68-4-9.1A26.75,26.75,0,0,1,81,96a35.21,35.21,0,0,1,2.64-5.64A30.5,30.5,0,0,1,94.2,79.21c3.83-2.21,7.35-2.53,9.89-1.07h0a145,145,0,0,0,14.46,5.29C131.15,87.25,144.2,86.36,156.34,84.7Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,128.48c-6.66,16.35-6.11,27.62-6.11,27.62-4.63-11.35-10.39-23.09-20-32.08a144.75,144.75,0,0,0-11.81-9.88h0c-2.54-1.48-4-4.68-4-9.1A26.75,26.75,0,0,1,81,96C92.81,101.88,111.86,112.75,121.23,128.48Z",
    style: {
      fill: "#FF7F00",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.62,106.87c0,10.25-3.16,21.46-8.41,31.82h0C170.48,152,160.33,163.8,149,170.36c-20.25,11.69-36.66,2.21-36.66-21.16a61.94,61.94,0,0,1,2.43-16.57A87.18,87.18,0,0,1,136.94,95q2.15-2.11,4.41-4c.63-.52,1.27-1,1.91-1.51h0c.91-.69,1.82-1.35,2.75-2S148,86.28,149,85.71C169.2,74,185.62,83.5,185.62,106.87Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,138.69C170.48,152,160.33,163.8,149,170.36c-20.25,11.69-36.66,2.21-36.66-21.16a61.94,61.94,0,0,1,2.43-16.57h0c1.37,3,6.29,7.34,8.5,4.31a56,56,0,0,0-2.13,14.7c0,6.72,1.5,12.14,4.33,15.68a12,12,0,0,0,9.86,4.56c4,0,8.68-1.47,13.49-4.25,9.67-5.58,18.56-15.61,24.87-27C173.65,140.66,174.91,141.72,177.21,138.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,108.18c0,10.32-3.62,22-9.46,32.48-6.31,11.36-15.2,21.39-24.87,27-4.81,2.78-9.47,4.25-13.49,4.25a12,12,0,0,1-9.86-4.56c-2.83-3.54-4.33-9-4.33-15.68a56,56,0,0,1,2.13-14.7c.51-1.9,1.12-3.8,1.81-5.7a82.39,82.39,0,0,1,4.32-9.81l1-2c.59-1.08,1.2-2.15,1.84-3.2a82.82,82.82,0,0,1,7.23-10.17l.09-.1a73.37,73.37,0,0,1,5.47-5.88q2.06-2,4.18-3.66.9-.72,1.8-1.38c.73-.53,1.47-1,2.21-1.53s1.46-.92,2.19-1.35c4.82-2.79,9.49-4.25,13.5-4.25C177.81,88,183.11,95.52,183.11,108.18Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,108.18c0,10.32-3.62,22-9.46,32.48-6.31,11.36-15.2,21.39-24.87,27-4.81,2.78-9.47,4.25-13.49,4.25a12,12,0,0,1-9.86-4.56c-2.83-3.54-4.33-9-4.33-15.68a56,56,0,0,1,2.13-14.7c.51-1.9,1.12-3.8,1.81-5.7a82.39,82.39,0,0,1,4.32-9.81l1-2c.59-1.08,1.2-2.15,1.84-3.2a82.82,82.82,0,0,1,7.23-10.17l.09-.1a73.37,73.37,0,0,1,5.47-5.88q2.06-2,4.18-3.66.9-.72,1.8-1.38c.73-.53,1.47-1,2.21-1.53s1.46-.92,2.19-1.35c4.82-2.79,9.49-4.25,13.5-4.25C177.81,88,183.11,95.52,183.11,108.18Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,113.92l-12.86,24c-3.62-1.36-9.73-3.53-14.71-4.8.2-.64.42-1.26.66-1.9a81.5,81.5,0,0,1,4.32-9.81c.34-.66.69-1.31,1-2,.59-1.08,1.2-2.15,1.84-3.19a82.07,82.07,0,0,1,7.23-10.17.48.48,0,0,0,.09-.11c.39-.46.78-.92,1.17-1.36A83.45,83.45,0,0,0,152,113.92Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152,113.92l-12.86,24c-3.62-1.36-9.73-3.53-14.71-4.8.2-.64.42-1.26.66-1.9a81.5,81.5,0,0,1,4.32-9.81c.34-.66.69-1.31,1-2,.59-1.08,1.2-2.15,1.84-3.19a82.07,82.07,0,0,1,7.23-10.17.48.48,0,0,0,.09-.11c.39-.46.78-.92,1.17-1.36A83.45,83.45,0,0,0,152,113.92Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.17,137.87c-2.91,0-4.64-2.35-4.64-6.28v-.12c0-6.18,4.35-13.73,9.71-16.82l.1-.06a8.41,8.41,0,0,1,4.06-1.26c2.9,0,4.64,2.35,4.64,6.29v.12c0,6.18-4.36,13.72-9.71,16.81l-.1.06a8.3,8.3,0,0,1-4.06,1.26Z",
    style: {
      fill: "#FF7F00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.17,137.87c-2.91,0-4.64-2.35-4.64-6.28v-.12c0-6.18,4.35-13.73,9.71-16.82l.1-.06a8.41,8.41,0,0,1,4.06-1.26c2.9,0,4.64,2.35,4.64,6.29v.12c0,6.18-4.36,13.72-9.71,16.81l-.1.06a8.3,8.3,0,0,1-4.06,1.26Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154,70.24a2.89,2.89,0,0,1-2.89-2.89v-28a2.89,2.89,0,0,1,5.78,0v28A2.89,2.89,0,0,1,154,70.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59,77.06a2.88,2.88,0,0,1-2.5-1.44l-14-24.22a2.89,2.89,0,0,1,5-2.9l14,24.22a2.89,2.89,0,0,1-2.51,4.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.12,211.84a2.9,2.9,0,0,1-2.5-4.34l14-24.22a2.89,2.89,0,1,1,5,2.89l-14,24.22A2.9,2.9,0,0,1,102.12,211.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,215.58a2.89,2.89,0,0,1-2.89-2.89v-28a2.89,2.89,0,1,1,5.78,0v28A2.89,2.89,0,0,1,154,215.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.48,189.44A2.89,2.89,0,0,1,191,188l-14-24.22a2.89,2.89,0,0,1,5-2.89l14,24.22a2.9,2.9,0,0,1-2.5,4.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.33,160.57a2.9,2.9,0,0,1-1.44-.38l-24.22-14a2.89,2.89,0,1,1,2.9-5l24.21,14a2.89,2.89,0,0,1-1.45,5.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,121.14h-28a2.89,2.89,0,1,1,0-5.78h28a2.89,2.89,0,1,1,0,5.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.12,95.69a2.89,2.89,0,0,1-1.45-5.4l24.22-14a2.89,2.89,0,1,1,2.89,5l-24.21,14A2.85,2.85,0,0,1,198.12,95.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,77.06A2.89,2.89,0,0,1,177,72.72L191,48.5a2.89,2.89,0,0,1,5,2.9L182,75.62A2.88,2.88,0,0,1,179.49,77.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdev2);
export default __webpack_public_path__ + "static/media/appdev2.d9ecb2710bd1509686ae2ba26cfd35c3.svg";
export { ForwardRef as ReactComponent };